import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchBarcodePackages = createAction(ACTION.FETCH_BARCODE_PACKAGES.REQUEST, params => params);
export const resetBarcode = createAction(ACTION.RESET_BARCODE);
export const setInputFocus = createAction(ACTION.SET_INPUT_FOCUS, input => ({input}));
export const setPackage = createAction(ACTION.SET_PACKAGE, payload => payload);
export const setPackagePage = createAction(ACTION.SET_PACKAGE_PAGE, (packageId, page = null) => ({packageId, page}));
export const clearState = createAction(ACTION.CLEAR_STATE);
